const PageTitle = ({ title }: { title: string }) => {
  return (
    <p className='mb-2 text-[40px] font-semibold text-[#002652]'>{title}</p>
  )
}

export default PageTitle
